export const RANDOM_ID = 99999;

export const STARTS_WITH_GBRAPPI_FORMAT = 'gbrappi://';
export const STARTS_WITH_WHATSAPP_FORMAT = 'https://wa.me/';

export const PAGINATION_INCREMENTAL = 20;
